import {useStyles} from "../styles/OddListeningStepStyle";
import {Box, Button, TextField, Typography} from "@material-ui/core";
import clsx from "clsx";
import React from "react";
import {withRouter} from "react-router-dom";
import {inject, observer} from "mobx-react";


function BeforeDividedState(props) {
    const classes = useStyles();

    const oddStepOneStore = props.oddStepOneStore;
    const content = oddStepOneStore.getSelectedContent();

    const onChangeTextField = (value) => {
        oddStepOneStore.setText(content, value);
        oddStepOneStore.clearPieceList(content);
    };

    const onClickDivideButton = () => {
        oddStepOneStore.saveTempContentList();
        oddStepOneStore.setDividedNumber(1);
        oddStepOneStore.setIsProcessing(true);
    };

    const onClickDivideButton2 = () => {
        oddStepOneStore.saveTempContentList();
        oddStepOneStore.setDividedNumber(2);
        oddStepOneStore.setIsProcessing(true);
    };

    const attemptToChange = (value) => {
        if (props.oddStepOneStore.askToRemove) {
            askToRemoveAll(value);
        } else {
            onChangeTextField(value);
        }
    }
    const askToRemoveAll = (value) => {
        props.dialogStore.openNewDialog({
            titleText: "본문 내용 수정",
            text:"본문을 수정하면 나누어진 문장이 초기화 됩니다. 그래도 수정하시겠습니까?",
            controlBtn:true,
            additionalActionOnConfirm:()=>onChangeTextField(value),
            clickButton:()=>closeAskingDialog()
        })
    }
    const closeAskingDialog = () => {
        props.oddStepOneStore.setChangeAskToRemove(false);
        props.dialogStore.closeDialog();
    }

    return (
        <>
            <Box>
                <TextField
                    id="outlined-multiline-static"
                    multiline
                    minrows={4}
                    placeholder="텍스트를 입력해주세요."
                    variant="outlined"
                    value={content.text}
                    onChange={(e) => attemptToChange(e.target.value)}
                />
            </Box>
            <Box display={"flex"} justifyContent={"flex-end"}>
                <Box className={clsx(classes.disabled, classes.buttonStyle)}>
                    <Button onClick={onClickDivideButton2} disableRipple>
                        <Typography>본문1 나누기</Typography>
                    </Button>
                </Box>
                <Box className={clsx(classes.disabled, classes.buttonStyle)} sx={{marginLeft: 10}}>
                    <Button onClick={onClickDivideButton}>
                        <Typography>본문2 나누기</Typography>
                    </Button>
                </Box>
            </Box>
        </>
    )
}

export default withRouter(inject('contentStore','oddStepOneStore','dialogStore')(observer(BeforeDividedState)));

